document.addEventListener('click', async (event) => {
  const productLink = event.target.closest('[data-product-card] a');
  if (!productLink) return;
  event.preventDefault();

  const productCard = event.target.closest('[data-product-card]');
  const productScriptTag = productCard.querySelector('[id^="Product-Item-Data-"]');
  let sectionScriptTag = false;
  const sectionTag = productCard.closest('.shopify-section');
  if (sectionTag) sectionScriptTag = sectionTag.querySelector('[id^="Product-List-Data-"]');

  const item = {
    data: productScriptTag ? JSON.parse(productScriptTag.innerHTML) : {},
    section: sectionScriptTag ? JSON.parse(sectionScriptTag.innerHTML) : {}
  };

  const items = [
    {...item.data, ...item.section}
  ];

  /* Push to dataLayer */
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'select_item',
    ecommerce: {
      items,
    },
  });
  console.log('%cEvent: select_item', 'color: #FF9100');
  console.log(window.dataLayer);

  window.location.href = productLink.getAttribute('href');
});